import { render, staticRenderFns } from "./save-changes.vue?vue&type=template&id=6c543cc8&"
import script from "./save-changes.vue?vue&type=script&lang=ts&"
export * from "./save-changes.vue?vue&type=script&lang=ts&"
import style0 from "./save-changes.vue?vue&type=style&index=0&id=6c543cc8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports